import { SetState } from 'zustand';
import '@ui5/webcomponents-react';
import { CommonABAPQueryState } from 'stores/interfaces/CommonQueryState';

import ValueState from '@ui5/webcomponents-base/dist/types/ValueState.js';

export const commonABAPQueryInitialStateFields = {
  system: '',
  objectType: '',
  objectName: '',
  objectOwner: '',
  collectionPackage: '',
  collectionOwner: '',
  applicationComponent: '',
  repositoryProgramType: '',
  repositoryProgramId: '',
  repositoryProgramName: '',
  translationArea: '',
  maxLength: undefined
};

export const commonABAPQueryInitialStateValueStates = {
  systemValueState: ValueState.None,
  objectTypeValueState: ValueState.None,
  objectNameValueState: ValueState.None,
  objectOwnerValueState: ValueState.None,
  collectionPackageValueState: ValueState.None,
  collectionOwnerValueState: ValueState.None,
  applicationComponentValueState: ValueState.None,
  repositoryProgramTypeValueState: ValueState.None,
  repositoryProgramIdValueState: ValueState.None,
  repositoryProgramNameValueState: ValueState.None,
  translationAreaValueState: ValueState.None
};

export const commonABAPQueryInitialState = {
  ...commonABAPQueryInitialStateFields,
  ...commonABAPQueryInitialStateValueStates,
  fetching: false
};

export const createCommonABAPQuerySlice = <T extends CommonABAPQueryState>(set: SetState<T>) => ({
  ...commonABAPQueryInitialState,

  setSystem: (value: string) => set(() => ({ system: value })),
  setObjectType: (value: string) => set(() => ({ objectType: value })),
  setObjectName: (value: string) => set(() => ({ objectName: value })),
  setObjectOwner: (value: string) => set(() => ({ objectOwner: value })),
  setCollectionPackage: (value: string) => set(() => ({ collectionPackage: value })),
  setCollectionOwner: (value: string) => set(() => ({ collectionOwner: value })),
  setLanguagesTranslatorTeams: (value: string) => set(() => ({ languagesTranslatorTeams: value })),
  setApplicationComponent: (value: string) => set(() => ({ applicationComponent: value })),
  setRepositoryProgramType: (value: string) => set(() => ({ repositoryProgramType: value })),
  setRepositoryProgramId: (value: string) => set(() => ({ repositoryProgramId: value })),
  setRepositoryProgramName: (value: string) => set(() => ({ repositoryProgramName: value })),
  setMaxLength: (value: number | null) =>
    set(() => ({ maxLength: value != null ? Number(value) : null })),
  setTranslationArea: (value: string) => set(() => ({ translationArea: value })),
  setSystemValueState: (value: ValueState) => set(() => ({ systemValueState: value })),
  setObjectTypeValueState: (value: ValueState) => set(() => ({ objectTypeValueState: value })),
  setObjectNameValueState: (value: ValueState) => set(() => ({ objectNameValueState: value })),
  setObjectOwnerValueState: (value: ValueState) => set(() => ({ objectOwnerValueState: value })),
  setCollectionPackageValueState: (value: ValueState) =>
    set(() => ({ collectionPackageValueState: value })),
  setCollectionOwnerValueState: (value: ValueState) =>
    set(() => ({ collectionOwnerValueState: value })),
  setApplicationComponentValueState: (value: ValueState) =>
    set(() => ({ applicationComponentValueState: value })),
  setRepositoryProgramTypeValueState: (value: ValueState) =>
    set(() => ({ repositoryProgramTypeValueState: value })),
  setRepositoryProgramIdValueState: (value: ValueState) =>
    set(() => ({ repositoryProgramIdValueState: value })),
  setRepositoryProgramNameValueState: (value: ValueState) =>
    set(() => ({ repositoryProgramNameValueState: value })),
  setTranslationAreaValueState: (value: ValueState) =>
    set(() => ({ translationAreaValueState: value })),

  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  resetData: () =>
    set({
      ...commonABAPQueryInitialStateFields,
      ...commonABAPQueryInitialStateValueStates
    })
});
